/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchGetComments} from '../api'

export const useMutationBatchGetComments = createReactQueryMutationHook('batchGetComments', batchGetComments)
